// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'shipments.painelDescargaPage.title': 'Painel de Descarga',
    'shipments.painelDescargaPage.eyebrow': 'Operação',
    'shipments.painelDescargaPage.colAvailableSince': 'Último Disponível',
    'shipments.painelDescargaPage.colAlerta': 'Alerta',
    'shipments.painelDescargaPage.macroVazio': 'Vazio',
    'shipments.painelDescargaPage.alertaGestao': 'Gestão',
    'shipments.painelDescargaPage.semAlerta': 'Sem alerta',
    'shipments.painelDescargaPage.searchAlert': 'Buscar alerta…',
    'shipments.painelDescargaPage.alertaGestaoTip_one': 'O motorista tem {{count}} gestão pendente no módulo de Gestões.',
    'shipments.painelDescargaPage.alertaGestaoTip_other': 'O motorista tem {{count}} gestões pendentes no módulo de Gestões.',
    'shipments.painelDescargaPage.macroVazioTip': 'O motorista avisou que o veículo ficou vazio. Clique para conferir a hora e confirmar o Disponível.',
    'shipments.painelDescargaPage.macroVazioSemSinalTip': 'A macro de vazio chegou sem a hora, porque o veículo estava fora da área de cobertura.',
    'shipments.painelDescargaPage.macroVazioIncompletaTip': 'A macro de vazio chegou incompleta, sem a data e a hora digitadas. Clique para preencher a hora à mão.',
    'shipments.painelDescargaPage.editAvailable': 'Editar disponível',
    'shipments.painelDescargaPage.dayOffUntil': 'até {{when}}',
    'shipments.painelDescargaPage.changeDayOffEnd': 'Alterar o último dia da folga',
    'shipments.painelDescargaPage.availableEdited': 'Último Disponível corrigido.',
    'shipments.painelDescargaPage.searchCurrentLocation': 'Buscar local atual…',
    'shipments.painelDescargaPage.filterModality': 'Modalidade',
    'shipments.painelDescargaPage.searchModality': 'Buscar modalidade…',
    'shipments.painelDescargaPage.kpiPairs': 'Conjuntos por dupla',
    'shipments.painelDescargaPage.pair': 'Dupla',
    // A COLUNA se chama Dupla do Conjunto, e o filtro continua Dupla. A regra do
    // Samuel, 18/09/2026, nomeia a coluna assim de propósito: ela é a Dupla HUB, e o
    // nome curto se confundia com a dupla do motorista, que é a do Protheus e vale
    // em Jornada e Diárias.
    'shipments.painelDescargaPage.pairOfSet': 'Dupla do Conjunto',
    'shipments.painelDescargaPage.driver': 'Motorista',
    'shipments.painelDescargaPage.plate': 'Placa',
    'shipments.painelDescargaPage.colTrailer': 'Carreta',
    'shipments.painelDescargaPage.colCurrentLocation': 'Local atual',
    'shipments.painelDescargaPage.colBase': 'Base',
    'shipments.painelDescargaPage.colOriginCity': 'Município origem',
    'shipments.painelDescargaPage.noBase': 'Sem base',
    'shipments.painelDescargaPage.noOriginCity': 'Sem município',
    'shipments.painelDescargaPage.searchBase': 'Buscar base…',
    'shipments.painelDescargaPage.searchOriginCity': 'Buscar município…',
    'shipments.painelDescargaPage.colUnloadingLocation': 'Local descarga',
    'shipments.painelDescargaPage.contract': 'Contrato',
    'shipments.painelDescargaPage.colLoadingDate': 'Data carregamento',
    'shipments.painelDescargaPage.colSundaysWorked': 'Domingos trabalhados',
    'shipments.painelDescargaPage.colSundaysInARow': 'Domingos seguidos',
    'shipments.painelDescargaPage.kpiSundaysFilter': 'Mostrar só os motoristas com {{faixa}} domingos seguidos',
    'shipments.painelDescargaPage.kpiSundaysClear': 'Tirar o filtro de {{faixa}} domingos seguidos',
    'shipments.painelDescargaPage.colDaysInARow': 'Dias trabalhados seguidos',
    'shipments.painelDescargaPage.colTrips': 'Quantidade de viagens',
    'shipments.painelDescargaPage.indicatorsWindow': 'Últimos 90 dias, contando hoje',
    'shipments.painelDescargaPage.showDriverIndicators': 'Mostrar os indicadores do motorista',
    'shipments.painelDescargaPage.showOperationalColumns': 'Voltar a Jornada, Placa, Carreta, Local atual e Local de descarga',
    'shipments.painelDescargaPage.searchLoadingDate': 'Buscar data…',
    'shipments.painelDescargaPage.colNotes': 'Observações',
    'shipments.painelDescargaPage.notRegisteredM': 'Não registrado',
    'shipments.painelDescargaPage.notRegisteredF': 'Não registrada',
    'shipments.painelDescargaPage.noCurrentLocation': 'Sem local atual',
    'shipments.painelDescargaPage.noContract': 'Sem contrato',
    'shipments.painelDescargaPage.justNow': 'agora',
    'shipments.painelDescargaPage.ago': 'há {{value}}',
    'shipments.painelDescargaPage.positionReceived': 'Posição recebida {{when}}',
    'shipments.painelDescargaPage.statusHistory': 'Histórico de status',
    'shipments.painelDescargaPage.trocaSoDeDisponivel': 'Para mudar para {{novo}}, o conjunto precisa estar Disponível. Status atual: {{atual}}.',
    'shipments.painelDescargaPage.statusSoPelaFrente': 'O conjunto está {{atual}} na Frente de Trabalho, e esse status só muda por lá. Para tirá-lo, exclua a escala ou encerre a viagem na Frente de Trabalho.',
    'shipments.painelDescargaPage.outrosServicosSoPorDisponivel': 'O conjunto está em Outros Serviços. Para tirá-lo, marque Disponível, que encerra a viagem do módulo Outros Serviços Transporte.',
    'shipments.painelDescargaPage.transferSet': 'Transferir o conjunto para outra dupla',
    'shipments.painelDescargaPage.colJourney': 'Jornada',
    'shipments.painelDescargaPage.noJourney': 'Sem jornada',
    'shipments.painelDescargaPage.journeyDay': 'Dia: {{value}}',
    'shipments.painelDescargaPage.journeyForecast': 'Previsão: {{value}}',
    'shipments.painelDescargaPage.journeyDsr': '{{value}} dias sem DSR',
    'shipments.painelDescargaPage.journeyUpdated': 'atualizado {{value}}',
    'shipments.painelDescargaPage.searchStatus': 'Buscar status…',
    'shipments.painelDescargaPage.searchPair': 'Buscar dupla…',
    'shipments.painelDescargaPage.filterLocal': 'Local',
    // O filtro é Observação, no singular, como no pedido do Samuel (24/09/2026); a
    // coluna continua Observações.
    'shipments.painelDescargaPage.filterNotes': 'Observação',
    'shipments.painelDescargaPage.indicators': 'Indicadores',
    'shipments.painelDescargaPage.kpiSets': 'Conjuntos',
    'shipments.painelDescargaPage.kpiModality': 'Modalidade',
    'shipments.painelDescargaPage.kpiNoModality': 'Sem modalidade',
    'shipments.painelDescargaPage.emptyFiltered': 'Nenhum conjunto corresponde aos filtros.',
    'shipments.painelDescargaPage.foraDoPainelTitulo': 'A busca achou conjunto fora do Painel de Descarga',
    'shipments.painelDescargaPage.foraDoPainelFuncao': 'O titular está com a função {{funcao}}, e o Painel mostra só quem tem a função Motorista. Para trazer o conjunto, troque a função na ficha dele em Pessoas.',
    'shipments.painelDescargaPage.foraDoPainelPrancha': 'O cavalo é de Prancha, que tem fila própria no Transporte de Máquina e não entra na fila de descarga.',
    'shipments.painelDescargaPage.foraDoPainelSemTitular': 'Sem titular',
    'shipments.painelDescargaPage.emptyDate': 'Nenhum conjunto no painel para esta data.',
    'shipments.painelDescargaPage.records_one': '{{count, number}} registro',
    'shipments.painelDescargaPage.records_other': '{{count, number}} registros',
  },
  en: {
    'shipments.painelDescargaPage.title': 'Unloading Panel',
    'shipments.painelDescargaPage.eyebrow': 'Operations',
    'shipments.painelDescargaPage.colAvailableSince': 'Last available',
    'shipments.painelDescargaPage.colAlerta': 'Alert',
    'shipments.painelDescargaPage.macroVazio': 'Empty',
    'shipments.painelDescargaPage.alertaGestao': 'Management',
    'shipments.painelDescargaPage.semAlerta': 'No alert',
    'shipments.painelDescargaPage.searchAlert': 'Search alert…',
    'shipments.painelDescargaPage.alertaGestaoTip_one': 'The driver has {{count}} pending management action in the Management module.',
    'shipments.painelDescargaPage.alertaGestaoTip_other': 'The driver has {{count}} pending management actions in the Management module.',
    'shipments.painelDescargaPage.macroVazioTip': 'The driver reported the vehicle is empty. Click to check the time and confirm Available.',
    'shipments.painelDescargaPage.macroVazioSemSinalTip': 'The empty macro arrived without the time because the vehicle was out of coverage.',
    'shipments.painelDescargaPage.macroVazioIncompletaTip': 'The empty macro arrived incomplete, without the typed date and time. Click to fill in the time manually.',
    'shipments.painelDescargaPage.editAvailable': 'Edit availability',
    'shipments.painelDescargaPage.dayOffUntil': 'until {{when}}',
    'shipments.painelDescargaPage.changeDayOffEnd': 'Change the last day off',
    'shipments.painelDescargaPage.availableEdited': 'Last available corrected.',
    'shipments.painelDescargaPage.searchCurrentLocation': 'Search current location…',
    'shipments.painelDescargaPage.filterModality': 'Type',
    'shipments.painelDescargaPage.searchModality': 'Search type…',
    'shipments.painelDescargaPage.kpiPairs': 'Sets per pair',
    'shipments.painelDescargaPage.pair': 'Pair',
    'shipments.painelDescargaPage.pairOfSet': 'Set pair',
    'shipments.painelDescargaPage.driver': 'Driver',
    'shipments.painelDescargaPage.plate': 'License plate',
    'shipments.painelDescargaPage.colTrailer': 'Trailer',
    'shipments.painelDescargaPage.colCurrentLocation': 'Current location',
    'shipments.painelDescargaPage.colBase': 'Base',
    'shipments.painelDescargaPage.colOriginCity': 'Origin city',
    'shipments.painelDescargaPage.noBase': 'No base',
    'shipments.painelDescargaPage.noOriginCity': 'No city',
    'shipments.painelDescargaPage.searchBase': 'Search base…',
    'shipments.painelDescargaPage.searchOriginCity': 'Search city…',
    'shipments.painelDescargaPage.colUnloadingLocation': 'Unloading location',
    'shipments.painelDescargaPage.contract': 'Contract',
    'shipments.painelDescargaPage.colLoadingDate': 'Loading date',
    'shipments.painelDescargaPage.colSundaysWorked': 'Sundays worked',
    'shipments.painelDescargaPage.colSundaysInARow': 'Sundays in a row',
    'shipments.painelDescargaPage.kpiSundaysFilter': 'Show only drivers with {{faixa}} Sundays in a row',
    'shipments.painelDescargaPage.kpiSundaysClear': 'Clear the {{faixa}} Sundays in a row filter',
    'shipments.painelDescargaPage.colDaysInARow': 'Days worked in a row',
    'shipments.painelDescargaPage.colTrips': 'Number of trips',
    'shipments.painelDescargaPage.indicatorsWindow': 'Last 90 days, including today',
    'shipments.painelDescargaPage.showDriverIndicators': 'Show driver indicators',
    'shipments.painelDescargaPage.showOperationalColumns': 'Back to Journey, Plate, Trailer, Current location and Unloading location',
    'shipments.painelDescargaPage.searchLoadingDate': 'Search date…',
    'shipments.painelDescargaPage.colNotes': 'Notes',
    'shipments.painelDescargaPage.notRegisteredM': 'Not registered',
    'shipments.painelDescargaPage.notRegisteredF': 'Not registered',
    'shipments.painelDescargaPage.noCurrentLocation': 'No current location',
    'shipments.painelDescargaPage.noContract': 'No contract',
    'shipments.painelDescargaPage.justNow': 'just now',
    'shipments.painelDescargaPage.ago': '{{value}} ago',
    'shipments.painelDescargaPage.positionReceived': 'Position received {{when}}',
    'shipments.painelDescargaPage.statusHistory': 'Status history',
    'shipments.painelDescargaPage.trocaSoDeDisponivel': 'To change to {{novo}}, the set must be Available. Current status: {{atual}}.',
    'shipments.painelDescargaPage.statusSoPelaFrente': 'The set is {{atual}} in the Work Front, and this status only changes there. To release it, delete the schedule or close the trip in the Work Front.',
    'shipments.painelDescargaPage.outrosServicosSoPorDisponivel': 'The set is in Other Services. To release it, mark Available, which closes the trip in the Other Transport Services module.',
    'shipments.painelDescargaPage.transferSet': 'Transfer the set to another pair',
    'shipments.painelDescargaPage.colJourney': 'Journey',
    'shipments.painelDescargaPage.noJourney': 'No journey',
    'shipments.painelDescargaPage.journeyDay': 'Day: {{value}}',
    'shipments.painelDescargaPage.journeyForecast': 'Forecast: {{value}}',
    'shipments.painelDescargaPage.journeyDsr': '{{value}} days without weekly rest',
    'shipments.painelDescargaPage.journeyUpdated': 'updated {{value}}',
    'shipments.painelDescargaPage.searchStatus': 'Search status…',
    'shipments.painelDescargaPage.searchPair': 'Search pair…',
    'shipments.painelDescargaPage.filterLocal': 'Location',
    'shipments.painelDescargaPage.filterNotes': 'Note',
    'shipments.painelDescargaPage.indicators': 'Indicators',
    'shipments.painelDescargaPage.kpiSets': 'Sets',
    'shipments.painelDescargaPage.kpiModality': 'Modality',
    'shipments.painelDescargaPage.kpiNoModality': 'No modality',
    'shipments.painelDescargaPage.emptyFiltered': 'No set matches the filters.',
    'shipments.painelDescargaPage.foraDoPainelTitulo': 'The search found a set outside the Unloading Panel',
    'shipments.painelDescargaPage.foraDoPainelFuncao': 'The holder has the {{funcao}} role, and the Panel only shows people with the Driver role. To bring the set back, change the role on their record in People.',
    'shipments.painelDescargaPage.foraDoPainelPrancha': 'The tractor is a Flatbed, which has its own queue in Machine Transport and does not enter the unloading queue.',
    'shipments.painelDescargaPage.foraDoPainelSemTitular': 'No holder',
    'shipments.painelDescargaPage.emptyDate': 'No set on the panel for this date.',
    'shipments.painelDescargaPage.records_one': '{{count, number}} record',
    'shipments.painelDescargaPage.records_other': '{{count, number}} records',
  },
  es: {
    'shipments.painelDescargaPage.title': 'Panel de descarga',
    'shipments.painelDescargaPage.eyebrow': 'Operación',
    'shipments.painelDescargaPage.colAvailableSince': 'Último disponible',
    'shipments.painelDescargaPage.colAlerta': 'Alerta',
    'shipments.painelDescargaPage.macroVazio': 'Vacío',
    'shipments.painelDescargaPage.alertaGestao': 'Gestión',
    'shipments.painelDescargaPage.semAlerta': 'Sin alerta',
    'shipments.painelDescargaPage.searchAlert': 'Buscar alerta…',
    'shipments.painelDescargaPage.alertaGestaoTip_one': 'El conductor tiene {{count}} gestión pendiente en el módulo de Gestiones.',
    'shipments.painelDescargaPage.alertaGestaoTip_other': 'El conductor tiene {{count}} gestiones pendientes en el módulo de Gestiones.',
    'shipments.painelDescargaPage.macroVazioTip': 'El conductor avisó que el vehículo quedó vacío. Haga clic para revisar la hora y confirmar el Disponible.',
    'shipments.painelDescargaPage.macroVazioSemSinalTip': 'La macro de vacío llegó sin la hora porque el vehículo estaba fuera de cobertura.',
    'shipments.painelDescargaPage.macroVazioIncompletaTip': 'La macro de vacío llegó incompleta, sin la fecha y la hora digitadas. Haga clic para completar la hora a mano.',
    'shipments.painelDescargaPage.editAvailable': 'Editar disponible',
    'shipments.painelDescargaPage.dayOffUntil': 'hasta {{when}}',
    'shipments.painelDescargaPage.changeDayOffEnd': 'Cambiar el último día de descanso',
    'shipments.painelDescargaPage.availableEdited': 'Último disponible corregido.',
    'shipments.painelDescargaPage.searchCurrentLocation': 'Buscar ubicación actual…',
    'shipments.painelDescargaPage.filterModality': 'Modalidad',
    'shipments.painelDescargaPage.searchModality': 'Buscar modalidad…',
    'shipments.painelDescargaPage.kpiPairs': 'Conjuntos por dupla',
    'shipments.painelDescargaPage.pair': 'Pareja',
    'shipments.painelDescargaPage.pairOfSet': 'Pareja del conjunto',
    'shipments.painelDescargaPage.driver': 'Conductor',
    'shipments.painelDescargaPage.plate': 'Placa',
    'shipments.painelDescargaPage.colTrailer': 'Remolque',
    'shipments.painelDescargaPage.colCurrentLocation': 'Ubicación actual',
    'shipments.painelDescargaPage.colBase': 'Base',
    'shipments.painelDescargaPage.colOriginCity': 'Municipio origen',
    'shipments.painelDescargaPage.noBase': 'Sin base',
    'shipments.painelDescargaPage.noOriginCity': 'Sin municipio',
    'shipments.painelDescargaPage.searchBase': 'Buscar base…',
    'shipments.painelDescargaPage.searchOriginCity': 'Buscar municipio…',
    'shipments.painelDescargaPage.colUnloadingLocation': 'Ubicación de descarga',
    'shipments.painelDescargaPage.contract': 'Contrato',
    'shipments.painelDescargaPage.colLoadingDate': 'Fecha de carga',
    'shipments.painelDescargaPage.colSundaysWorked': 'Domingos trabajados',
    'shipments.painelDescargaPage.colSundaysInARow': 'Domingos seguidos',
    'shipments.painelDescargaPage.kpiSundaysFilter': 'Mostrar solo los conductores con {{faixa}} domingos seguidos',
    'shipments.painelDescargaPage.kpiSundaysClear': 'Quitar el filtro de {{faixa}} domingos seguidos',
    'shipments.painelDescargaPage.colDaysInARow': 'Días trabajados seguidos',
    'shipments.painelDescargaPage.colTrips': 'Cantidad de viajes',
    'shipments.painelDescargaPage.indicatorsWindow': 'Últimos 90 días, contando hoy',
    'shipments.painelDescargaPage.showDriverIndicators': 'Mostrar los indicadores del conductor',
    'shipments.painelDescargaPage.showOperationalColumns': 'Volver a Jornada, Placa, Remolque, Ubicación actual y Local de descarga',
    'shipments.painelDescargaPage.searchLoadingDate': 'Buscar fecha…',
    'shipments.painelDescargaPage.colNotes': 'Observaciones',
    'shipments.painelDescargaPage.notRegisteredM': 'No registrado',
    'shipments.painelDescargaPage.notRegisteredF': 'No registrada',
    'shipments.painelDescargaPage.noCurrentLocation': 'Sin ubicación actual',
    'shipments.painelDescargaPage.noContract': 'Sin contrato',
    'shipments.painelDescargaPage.justNow': 'ahora',
    'shipments.painelDescargaPage.ago': 'hace {{value}}',
    'shipments.painelDescargaPage.positionReceived': 'Posición recibida {{when}}',
    'shipments.painelDescargaPage.statusHistory': 'Historial de estados',
    'shipments.painelDescargaPage.trocaSoDeDisponivel': 'Para cambiar a {{novo}}, el conjunto debe estar Disponible. Estado actual: {{atual}}.',
    'shipments.painelDescargaPage.statusSoPelaFrente': 'El conjunto está {{atual}} en el Frente de Trabajo, y ese estado solo cambia allí. Para liberarlo, elimine la programación o cierre el viaje en el Frente de Trabajo.',
    'shipments.painelDescargaPage.outrosServicosSoPorDisponivel': 'El conjunto está en Otros Servicios. Para liberarlo, marque Disponible, que cierra el viaje del módulo Otros Servicios de Transporte.',
    'shipments.painelDescargaPage.transferSet': 'Transferir el conjunto a otra pareja',
    'shipments.painelDescargaPage.colJourney': 'Jornada',
    'shipments.painelDescargaPage.noJourney': 'Sin jornada',
    'shipments.painelDescargaPage.journeyDay': 'Día: {{value}}',
    'shipments.painelDescargaPage.journeyForecast': 'Previsión: {{value}}',
    'shipments.painelDescargaPage.journeyDsr': '{{value}} días sin DSR',
    'shipments.painelDescargaPage.journeyUpdated': 'actualizado {{value}}',
    'shipments.painelDescargaPage.searchStatus': 'Buscar estado…',
    'shipments.painelDescargaPage.searchPair': 'Buscar pareja…',
    'shipments.painelDescargaPage.filterLocal': 'Lugar',
    'shipments.painelDescargaPage.filterNotes': 'Observación',
    'shipments.painelDescargaPage.indicators': 'Indicadores',
    'shipments.painelDescargaPage.kpiSets': 'Conjuntos',
    'shipments.painelDescargaPage.kpiModality': 'Modalidad',
    'shipments.painelDescargaPage.kpiNoModality': 'Sin modalidad',
    'shipments.painelDescargaPage.emptyFiltered': 'Ningún conjunto coincide con los filtros.',
    'shipments.painelDescargaPage.foraDoPainelTitulo': 'La búsqueda encontró un conjunto fuera del Panel de Descarga',
    'shipments.painelDescargaPage.foraDoPainelFuncao': 'El titular tiene la función {{funcao}}, y el Panel muestra solo a quien tiene la función Conductor. Para traer el conjunto, cambie la función en su ficha en Personas.',
    'shipments.painelDescargaPage.foraDoPainelPrancha': 'El tractor es de Plataforma, que tiene fila propia en Transporte de Máquina y no entra en la fila de descarga.',
    'shipments.painelDescargaPage.foraDoPainelSemTitular': 'Sin titular',
    'shipments.painelDescargaPage.emptyDate': 'Ningún conjunto en el panel para esta fecha.',
    'shipments.painelDescargaPage.records_one': '{{count, number}} registro',
    'shipments.painelDescargaPage.records_other': '{{count, number}} registros',
  },
}
